'use strict';

var cleanWooRankLinks = require('./cleanWoorankLinks');

function replaceExtLink () {
  if (window.isSharedReview) {
    return cleanWooRankLinks();
  }
}

module.exports = replaceExtLink;
